var React = require('react');

function IcnDiskWiper (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"icn-DiskWiper","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("path",{"d":"M12,2 L12,8 L19,8 L19,10 L5,10 L5,2 L12,2 Z M14,2 L19,6 L14,6 L14,2 Z M5,12 L19,12 L19,18 L5,18 L5,12 Z M5,20 L19,20 L19,22 L5,22 L5,20 Z","id":"Combined-Shape","fill":"#000"}))]);
}

IcnDiskWiper.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = IcnDiskWiper;

IcnDiskWiper.default = IcnDiskWiper;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/images/icn-DiskWiper.svg
// module id = 432
// module chunks = 0